import { render, staticRenderFns } from "./KTCInstallmentPlanCreate.vue?vue&type=template&id=2a2bc7b1&"
import script from "./KTCInstallmentPlanCreate.vue?vue&type=script&lang=js&"
export * from "./KTCInstallmentPlanCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports